<template>
  <div v-if="pageCount != 0">
    <span v-if="counter.n !== -1" class="font-weight-bold bluetext">
        <!-- TBT -->Treffer {{ counter.n }} - {{counter.m }} / {{ counter.total }}
    </span>
    <span v-if="info && info.time"> <SqlDetails :timeTaken="info.time" :sqlStatement="info.sql"></SqlDetails></span>
    <v-pagination v-model="page" :total-visible="7" :length="pageCount" @input="onPageChange" ref="pager"></v-pagination>
    </div>
  <div v-else-if="pageCount == 0">
    <span class="font-weight-bold bluetext"><!-- TBT -->Keine Treffer</span>
  </div>
</template>

<script>
import Vue from "vue";
import SqlDetails from "./SqlDetails.vue";

export default {
  name: 'HitlistPager',
  props: [ 'pageChangeEventName' ],
  components: { SqlDetails },

  // incoming: totalHits, hitsPerPage

  data () {
    return {
      page: 0,
      pageCount: 0,
      hitsPerPage: -1,
      info: null,

      counter: {
        n: -1,
        m: -1,
        total: -1
      }
    }
  },
  methods: {
    onPageChange (event) {
      Vue.prototype.$eventHub.$emit(this.$props.pageChangeEventName, event);
    },

    onUpdateHitlistPager (data) {
      if (data.hitsPerPage !== undefined) {
        this.hitsPerPage = +data.hitsPerPage;
      }
      if (data.totalHits !== undefined) {
        this.counter.total = +data.totalHits;
      }
      if (data.page) {
        this.page = data.page;
      }
      if (this.counter.total > 0) {
        // this.counter.n = 1;
        // this.counter.m = Math.min(this.hitsPerPage, this.counter.total);
        this.counter.n = this.counter.total != 0 ? (this.page-1) * this.hitsPerPage + 1 : 0;
        this.counter.m = Math.min(this.counter.n + this.hitsPerPage - 1, this.counter.total);
        this.pageCount = Math.floor(this.counter.total / this.hitsPerPage) + 1;
      } else {
        this.counter.n = 0;
        this.counter.m = 0;
        this.counter.total = 0;
        this.pageCount = 0;
      }
      if (data.info)  {
        this.info = data.info;
      }
    }
  },
  created () {
    Vue.prototype.$eventHub.$on('updatehitlistpager', this.onUpdateHitlistPager);
  },
  destroyed () {
    Vue.prototype.$eventHub.$off('updatehitlistpager', this.onUpdateHitlistPager);
  },
}
</script>



// WEBPACK FOOTER //
// src/components/widgets/HitlistPager.vue